(ns frontend.view.settings2.security.ai-admin.model
  "State paths for the AI services admin panel (tenant-admin configuration of
   per-tenant AI providers and per-task-type routing)."
  (:require
   [common.schema.entities.integration.ai-options :as ai-options]))

(def root-path [::state])

(def blank-service
  {:label    ""
   :provider nil
   :base-url ""
   :model    ""
   :api-key  ""
   :enabled? true})

(defn ai-status
  "The one-line health of the tenant AI setup, for the status header. Returns
   {:state <keyword> :service <default-service-or-nil>}. The state is one of:
   :no-services, :no-default, :default-disabled, :active-unverified, :active.
   A service is active only when it is the default, it is enabled, and its last
   verification passed."
  [{:keys [services default-service-id verifications]}]
  (let [default (some (fn [s] (when (= (:id s) default-service-id) s)) services)]
    (cond
      (empty? services)         {:state :no-services}
      (nil? default)            {:state :no-default}
      (not (:enabled? default)) {:state :default-disabled
                                 :service default}
      (contains? ai-options/verification-passed
                 (:outcome (get verifications default-service-id)))
      {:state   :active
       :service default}
      :else {:state   :active-unverified
             :service default})))
